export function encodeHtml(text: string) {
    return text.replace(
        /[&<>"']/g,
        (ch) => (({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }) as any)[ch]
    );
}

export function intoHtml(strs: TemplateStringsArray, ...vals: (string | number | { raw: string | number })[]) {
    vals = vals.map((x) => (typeof x === 'object' ? x.raw : encodeHtml('' + x)));

    return String.raw({ raw: strs }, ...vals);
}
